import $ from "jquery";

class HeaderNew {
    constructor() {
        this.menuLvl1 = document.querySelectorAll('.menu-new > .menu-item');
        this.menuLvl2 = document.querySelectorAll('.menu-new .menu-item .menu > .menu-item');
        this.doubleColumnMenu = document.querySelectorAll('.menu-double-column > .menu');
        this.backButton = document.querySelector('.header__back-arrow');
        this.headerNew = document.querySelector('.header-new');
        this.headerBurger = document.querySelector('.header__burger');
        this.body = document.body;
        this.isTablet = window.innerWidth < 992;
        this.init();
    }

    init() {
        //Desktop
        this.menuOpenHandler(this.menuLvl1, true, 1)
        this.menuOpenHandler(this.menuLvl2, false, 2)
        this.doubleColumnHandler()
        this.menuCloseHandler()

        //Mobile
        this.menuOpenHandlerMobile(this.menuLvl1, true)
        this.menuOpenHandlerMobile(this.menuLvl2)
        this.menuCloseHandlerMobile()
        this.menuBackButtonHandler()
    }

    menuOpenHandler(menu, shouldToggle = true, level) {
        if (this.isTablet) {
            return
        }

        let checkSubstrateHeight = function (item) {
            let substrate = $(item).parent().prev();
            let menuLevel3 = $(item).find('> ul.menu');
            if (menuLevel3.height() + 50 > substrate.height()) {
                substrate.height(menuLevel3.height() + 50)
            } else {
                substrate.height('auto')
            }
        }

        menu && menu.forEach((item) => {
            const spanElement = item.querySelector('span');
            spanElement && spanElement.addEventListener('click', () => {
                if (level === 2) {
                    checkSubstrateHeight(item);
                }
                if (item.classList.contains('active') && !shouldToggle) {
                    return
                }

                menu.forEach((element) => {
                    if (element !== item) {
                        element.classList.remove('active');
                    }
                });

                item.classList.toggle('active');
                this.body.classList.add('body-active-overlay');
                this.activeNextLvlHandler(item)

                if (this.menuLvl1 && !Array.from(this.menuLvl1).some(item => item.classList.contains('active'))) {
                    this.body.classList.remove('body-active-overlay');
                }
            });
        });
    }

    doubleColumnHandler() {
        this.doubleColumnMenu && this.doubleColumnMenu.forEach((menu) => {
            const firstColumn = document.createElement('ul');
            firstColumn.classList.add('menu-column-one')
            const secondColumn = document.createElement('ul');
            secondColumn.classList.add('menu-column-two')
            const wrapperColumn = document.createElement('li');
            wrapperColumn.classList.add('wrapper-column-one')
            let isSecondColumn = false;

            const menuItems = menu.querySelectorAll('.menu-item')
            menuItems && menuItems.forEach((menuItem) => {
                if (menuItem.classList.contains('column-two')) {
                    isSecondColumn = true;
                }
                if (isSecondColumn) {
                    secondColumn.appendChild(menuItem.cloneNode(true));
                } else {
                    firstColumn.appendChild(menuItem.cloneNode(true));
                }
                menuItem.remove()
            })
            wrapperColumn.appendChild(firstColumn);
            wrapperColumn.appendChild(secondColumn);
            menu.appendChild(wrapperColumn);
        })
    }

    menuCloseHandler() {
        this.body && this.body.addEventListener('click', (event) => {
            if (this.body === event.target && this.body.classList.contains('body-active-overlay')) {
                const menuItemsAll = document.querySelectorAll('.menu-new .menu-item');
                this.body.classList.remove('body-active-overlay');
                this.headerBurger.classList.remove("active");
                this.backButton.classList.remove("active");
                this.headerNew.classList.remove("active");
                document.documentElement.classList.remove("noscroll-mobile");

                menuItemsAll && menuItemsAll.forEach((item) => {
                    item.classList.remove('active');
                });
            }
        });
    }

    menuOpenHandlerMobile(menu, hideSiblingElements = false) {
        if (!this.isTablet) {
            return
        }

        menu && menu.forEach((item) => {
            const spanElement = item.querySelector('span');
            spanElement && spanElement.addEventListener('click', (event) => {
                if (!item.classList.contains('menu-item--expanded')) {
                    return;
                }

                if (hideSiblingElements) {
                    menu.forEach((otherItem) => {
                        if (otherItem === item) {
                            otherItem.classList.add('active');
                        } else {
                            otherItem.classList.add('hide');
                        }
                    });
                } else {
                    menu.forEach((otherItem) => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
                    item.classList.toggle('active');
                }

                this.backButton.classList.add('active')
                this.body.classList.add('body-active-overlay');
            });
        })
    }

    menuBackButtonHandler() {
        this.backButton && this.backButton.addEventListener('click', () => {
            this.resetMenuState(this.menuLvl1)
            this.resetMenuState(this.menuLvl2)
        })
    }

    menuCloseHandlerMobile() {
        if (!this.headerBurger || !this.headerNew || !this.backButton) {
            return;
        }

        this.headerBurger.addEventListener('click', (e) => {
            this.resetMenuState(this.menuLvl1)
            this.resetMenuState(this.menuLvl2)
            this.backButton.classList.remove("active");
            this.body.classList.toggle('body-active-overlay');
        });
    }

    resetMenuState(menu) {
        menu.forEach((item) => {
            item.classList.remove('active', 'hide');
        });
        this.backButton.classList.remove('active')
    }

    activeNextLvlHandler(item) {
        if (item.classList.contains('active-green')) {
            const nextLvlActiveGreenItem = item.querySelector('.active-green');
            nextLvlActiveGreenItem && nextLvlActiveGreenItem.classList.add('active')

            return
        }

        const nextLvl = item.querySelectorAll('.menu > .menu-item');

        if (nextLvl.length > 0 && !$(item).find('> .menu > .menu-item.active').length) {
            const nextLvlSpan = nextLvl[0].querySelector('span');

            if (nextLvlSpan) {
                nextLvl[0].classList.add('active');
            }
        }
    }
}

export default HeaderNew;
